import React from 'react'
import { Image } from 'react-bootstrap'
import { Link } from '@mui/material'
import dynamic from "next/dynamic";

const HocButton = dynamic(() => import('../../HigherOrderComponent/HocButton'))

const BlogCta = (props) => {
  let { block, handleShowConnect, handleShowRate, handleShowBusiness } = props

  const HandleClick = () => {
    switch (block.type) {
      case 'type-1':
        handleShowConnect()
        break
      case 'type-2':
        handleShowRate()
        break
      case 'type-3':
        handleShowBusiness()
        break
      default:
        break
    }
  }

  const MutedCtaSection = () => (
    <section className="book-section bd-book-section">
      <div className="book-inner">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="book-box">
                <div className="row justify-content-center">
                  <div className="col-lg-12 col-md-12">
                    <div className="book-text">
                      <h2>{block.title}</h2>
                      <p>{block?.text}</p>
                      {block?.buttons?.[0]?.link ?
                        <div className="hire-btn">
                          <HocButton
                            button={block?.buttons?.[0]?.link}
                            btnAction={() => HandleClick()}
                          >
                            <Link
                              href={block?.buttons?.[0]?.link?.href}
                              className="btn btn-primary decoration-none"
                            >
                              {block?.buttons[0]?.link?.label}
                            </Link>
                          </HocButton>
                        </div>
                      :null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )

  const PrimaryCtaSection = () => (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="blog-banner">
            <h2>{block.title} </h2>
            <p>{block?.text}</p>
            {block?.buttons?.[0]?.link ?
              <HocButton
                button={block?.buttons?.[0]?.link}
                btnAction={() => HandleClick()}
              >
                <Link
                  href={block?.buttons?.[0]?.link?.href}
                  className="btn btn-primary decoration-none"
                >
                  {block?.buttons[0]?.link?.label}
                </Link>
              </HocButton>
            : null}
          </div>
        </div>
      </div>
    </div>
  )

  const SecondaryCtaSection = () => (
    <div className="container">
      <div className="blog-banner2">
        <div className="row">
          <div className="col-sm-3">
            <div className="col-bg">
              <div className="blog-banner-img">
                <Image src="/images/graph-icon.png" alt="graph-icon" />
              </div>
            </div>
          </div>
          <div className="col-sm-9">
            <div className="blog-banner2-text">
              <h2>{block.title} </h2>
              <p>{block?.text}</p>
              {block?.buttons?.[0]?.link ?
                <HocButton
                  button={block?.buttons?.[0]?.link}
                  btnAction={() => HandleClick()}
                >
                  <Link
                    href={block?.buttons?.[0]?.link?.href}
                    className="btn btn-primary decoration-none"
                  >
                    {block?.buttons[0]?.link?.label}
                  </Link>
                </HocButton>
              : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  switch (block.theme) {
    case 'primary':
      return <PrimaryCtaSection />
    case 'secondary':
      return <SecondaryCtaSection />
    case 'muted':
      return <MutedCtaSection />
    default:
      return <></>
  }
}

export default BlogCta
